import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../styles/Guide.module.scss";
import {
  blogListArray1,
  blogListArray2,
  blogListArray3,
  blogListArray4,
} from "../data/guide";
const Guide = ({ title }) => {
  useEffect(() => {
    document.title = "Briding 365 | Development Finance";
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation().pathname;
  // const blogListArray1 = [
  //   {
  //     id: 1,
  //     title: "Large Bridging Loans",
  //     path: "/bridgingloansblogs/blog1",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 2,
  //     title: "Bridging Loans bad credit",
  //     path: "/bridgingloansblogs/blog2",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 3,
  //     title: "Bridging Loans Nationwide",
  //     path: "/bridgingloansblogs/blog3",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 4,
  //     title: "Bridging Loans HSBC",
  //     path: "/bridgingloansblogs/blog4",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 5,
  //     title: "Barclays Bridging Loans",
  //     path: "/bridgingloansblogs/blog5",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 6,
  //     title: "Bridging Loan example",
  //     path: "/bridgingloansblogs/blog6",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 7,
  //     title: "Bridging Loans for bad credit",
  //     path: "/bridgingloansblogs/blog7",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 8,
  //     title: "Commercial Bridging Loans",
  //     path: "/bridgingloansblogs/blog8",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 9,
  //     title: "Fast Bridging Loans",
  //     path: "/bridgingloansblogs/blog9",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 10,
  //     title: "Inherited Property Bridging Loans",
  //     path: "/bridgingloansblogs/blog10",
  //     section: "bLoans",
  //   },
  //   {
  //     id: 11,
  //     title: "Difficult Bridging Loans",
  //     path: "/bridgingloansblogs/blog11",
  //     section: "bLoans",
  //   },
  // ];
  // const blogListArray2 = [
  //   {
  //     id: 1,
  //     title: "100% Development Funding",
  //     path: "/developmentfinanceblogs/blog1",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 2,
  //     title: "Large Development Finance",
  //     path: "/developmentfinanceblogs/blog2",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 3,
  //     title: "Development Finance with bad credit",
  //     path: "/developmentfinanceblogs/blog3",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 4,
  //     title: "Development Finance application form",
  //     path: "/developmentfinanceblogs/blog4",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 5,
  //     title: "Development Loan First Time Developer",
  //     path: "/developmentfinanceblogs/blog5",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 6,
  //     title: "Splitting Deeds",
  //     path: "/developmentfinanceblogs/blog6",
  //     section: "dFinanace",
  //   },
  //   {
  //     id: 7,
  //     title: "Converting your home into flats",
  //     path: "/developmentfinanceblogs/blog7",
  //     section: "dFinanace",
  //   },
  // ];
  // const blogListArray3 = [
  //   {
  //     id: 1,
  //     title: "Bridging Loans for Bankruptcy",
  //     path: "/casestudies1",
  //     section: "caseStudies",
  //   },
  //   {
  //     id: 2,
  //     title: "Bridging Loan for over 60's",
  //     path: "/casestudies2",
  //     section: "caseStudies",
  //   },
  //   {
  //     id: 3,
  //     title: "Bridging Loan for splitting title deeds",
  //     path: "/casestudies3",
  //     section: "caseStudies",
  //   },
  //   {
  //     id: 4,
  //     title: "Bridging loan for paying off sibling in an inherited Property",
  //     path: "/casestudies4",
  //     section: "caseStudies",
  //   },
  // ];
  // const blogListArray4 = [
  //   {
  //     id: 1,
  //     title: "Apply now to stop a repossession",
  //     path: "/stoprepossessionsblogs/blog1",
  //     section: "sRepo",
  //   },
  //   {
  //     id: 2,
  //     title: "How to stop your mortgage lender from repossessing your home",
  //     path: "/stoprepossessionsblogs/blog2",
  //     section: "sRepo",
  //   },
  // ];

  console.log(location);
  const [finalArray, setFinalArray] = useState([]);
  const [heading, setHeading] = useState("");

  useEffect(() => {
    setFinalArray(
      location === "/bridgingloans/guide"
        ? blogListArray1
        : location === "/developmentfinance/guide"
        ? blogListArray2
        : location === "/casestudies/guide"
        ? blogListArray3
        : location === "/stoprepossessions/guide"
        ? blogListArray4
        : blogListArray1
    );
    setHeading(
      location === "/bridgingloans/guide"
        ? "Bridging Loans"
        : location === "/developmentfinance/guide"
        ? "Development Finance"
        : location === "/casestudies/guide"
        ? "Case studies"
        : location === "/stoprepossessions/guide"
        ? "Stop Reposessions"
        : location === "/rebridgingloans/guide"
        ? "Rebridging Loans"
        : ""
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={classNames(
        styles.guide,
        heading === "Bridging Loans"
          ? styles.bLoans
          : heading === "Development Fianance"
          ? styles.dFinance
          : heading === "Stop Repossessions"
          ? styles.sRepo
          : heading === "Case studies"
          ? styles.reSources
          : styles.bLoans
      )}
    >
      <p className={styles.topText}>
        {" "}
        Buying a house for the first time can be daunting. Although we're here
        to make it as simple and stress free as possible, it’s important that
        you understand how it works. We hope you'll find our expert mortgage
        guides and calculators a helpful starting point. Once you're ready to
        discuss your mortgage requirements, our qualified mortgage advisers are
        on hand to help you 7 days a week. No need to make an appointment – our
        award-winning, fee free mortgage advice is just a phone call away.
      </p>
      <div className={styles.content}>
        <div className={styles.left}>
          <p
            onClick={() => {
              setFinalArray(blogListArray1);
              setHeading("Bridging Loans");
              window.scrollTo(0, 0);
            }}
            className={classNames(styles.section, styles.bLoans)}
          >
            Bridging Loans
          </p>
          <p
            onClick={() => {
              setFinalArray(blogListArray2);
              setHeading("Development Fianance");
              window.scrollTo(0, 0);
            }}
            className={classNames(styles.section, styles.dFinance)}
          >
            Development Finance
          </p>
          <p
            onClick={() => {
              setFinalArray(blogListArray4);
              setHeading("Stop Repossessions");
              window.scrollTo(0, 0);
            }}
            className={classNames(styles.section, styles.sRepo)}
          >
            Stop Repossession
          </p>
          <p
            onClick={() => {
              setFinalArray(blogListArray3);
              setHeading("Case studies");
              window.scrollTo(0, 0);
            }}
            className={classNames(styles.section, styles.caseStudies)}
          >
            Case Studies
          </p>
        </div>
        <div className={styles.right}>
          <p className={styles.rightHead}>
            {" "}
            <strong>
              {" "}
              {heading} Blogs
              {finalArray.length === 0 ? "(To be added soon)" : ""}{" "}
            </strong>{" "}
          </p>
          {finalArray.map((item) => {
            return (
              <div className={styles.blogTitleList}>
                <Link
                  className={
                    item.section === "bLoans"
                      ? styles.bLoans
                      : item.section === "dFinanace"
                      ? styles.dFinanace
                      : item.section === "caseStudies"
                      ? styles.caseStudies
                      : item.section === "sRepo"
                      ? styles.sRepo
                      : ""
                  }
                  to={item.path}
                >
                  {item.title}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Guide;
